export default __webpack_public_path__ + "static/media/final-step2.42d9f668.jpeg";